import styled from '@emotion/styled';

interface Props {
  src: string;
}

const StyledTableCell = styled.div`
  display: flex;
  white-space: normal !important;
`;

export const MultiLineCell = ({ src }: Props) => {
  return <StyledTableCell>{src}</StyledTableCell>;
};
